import { render, staticRenderFns } from "./DecidedProposals.vue?vue&type=template&id=9af1bb3e&scoped=true&"
import script from "./DecidedProposals.vue?vue&type=script&lang=js&"
export * from "./DecidedProposals.vue?vue&type=script&lang=js&"
import style0 from "./DecidedProposals.vue?vue&type=style&index=0&id=9af1bb3e&prod&lang=css&"
import style1 from "./DecidedProposals.vue?vue&type=style&index=1&id=9af1bb3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af1bb3e",
  null
  
)

export default component.exports